// Canvelle customization (HORIZON-THEME.md §1.21) — custom file, survives Horizon
// upgrades, but only does anything while the gallery snippet renders photos 3+ with
// loading="lazy" (snippets/product-media-gallery-content.liquid, same section).
//
// A shopper who never swipes the product gallery never downloads photos 3 and up.
// The first time a shopper touches, drags, clicks, wheels, focuses or (with a
// mouse) points at a product gallery, the rest start loading at once, so a swipe
// never lands on an empty slide. A gallery rebuilt by a colour change
// (assets/canvelle-variant-media.js) is lazy again and wakes the same way.

const LAZY_SLIDES = 'slideshow-slide img.product-media__image[loading="lazy"]';

/** @param {EventTarget | null} target */
function wake(target) {
  const gallery = target instanceof Element ? target.closest('media-gallery') : null;
  if (!gallery) return;
  for (const image of gallery.querySelectorAll(LAZY_SLIDES)) image.removeAttribute('loading');
}

// Deliberately NOT 'scroll': a colour change scrolls the old gallery back to its
// first photo, which would wake (download) the photos of the colour being left.
// A real swipe always starts with touchstart/pointerdown; a trackpad swipe is wheel.
const options = { capture: true, passive: true };
for (const type of ['pointerdown', 'touchstart', 'wheel', 'focusin', 'keydown']) {
  document.addEventListener(type, (event) => wake(event.target), options);
}
// A mouse over the gallery on a computer usually means arrows or thumbnails are next.
document.addEventListener(
  'pointerover',
  (event) => {
    if (event.pointerType === 'mouse') wake(event.target);
  },
  options
);
